import * as Yup from "yup";

export const validationSchema = Yup.object({
  calibrationDate: Yup.string().required("Please select the date of last calibration."),
  calibratedBy: Yup.string().trim().max(100, "Maximum 100 characters."),
});
